import React from 'react';

import ReactEcharts from 'echarts-for-react';

import useThemeColorMode from '@qality/common-utils/src/hooks/useThemeColorMode';

import { registerEChartsThemes } from '../ChartThemes';

export interface BarChartProps {
  height?: number;
  seriesData?: {
    name: string;
    data: {
      name: string;
      stack?: string;
      data: number[];
    }[];
  }[];
  axis?: string[];
}

registerEChartsThemes();

export const BarChart: React.FC<BarChartProps> = ({
  height,
  seriesData = [],
  axis,
}: BarChartProps) => {
  const themeColorMode = useThemeColorMode();

  const echartsOptionConfig = {
    tooltip: {
      trigger: 'axis',
      axisPointer: {
        // Use axis to trigger tooltip
        type: 'shadow', // 'shadow' as default; can also be 'line' or 'shadow'
      },
    },
    legend: {
      data: axis,
    },
    grid: {
      left: '3%',
      right: '4%',
      bottom: '3%',
      containLabel: true,
    },
    yAxis: {
      type: 'value',
    },
    xAxis: {
      type: 'category',
      data: axis,
      axisLabel: {
        interval: 0,
        rotate: 30,
      },
    },
    series: seriesData.map((serieData) => ({
      type: 'bar',
      stack: 'total',
      label: {
        show: false,
      },
      emphasis: {
        focus: 'series',
      },
      ...serieData,
    })),
  };

  return (
    <ReactEcharts
      style={{ height }}
      option={echartsOptionConfig}
      theme={themeColorMode}
    />
  );
};
